module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-2@3x.jpg?3eb58770";